<template>
<div class="wrongbook">
  <Header></Header>
  <div class="detail-wrapper">
  <div class="container" style="padding-top:70px;">
    <Breadcrumb class="breadcrumb">
      <BreadcrumbItem to="/">
        <Icon type="ios-home" class="home" />首页
      </BreadcrumbItem>
      <BreadcrumbItem>学习中心</BreadcrumbItem>
      <BreadcrumbItem>{{ categoryInfo.title }}</BreadcrumbItem>
      <BreadcrumbItem>错题本</BreadcrumbItem>
    </Breadcrumb>

    <div class="practice-header">
      <div class="practice-title">
        <h1>{{ categoryInfo.title }}</h1>
      </div>
      <div class="practice-progress">
        <span class="practice-progress-text"
          >共 {{ this.exerciseList.length }} 道题</span
        >
        <div class="practice-progress-bar">
          <Progress :percent="progressPercent" />
        </div>
      </div>
    </div>

    <div class="practice-container clearfix">
      <div class="fl practice-main">
        <div class="practice-nodata" v-show="exerciseList.length == 0">
          <img
            src="../../assets/nodata-video.png"
            alt="错题本内还没有错题"
          />
          <p class="am-margin-top">错题本内还没有错题</p>
        </div>
        <practice-item
          ref="practiceItem"
          v-for="(item, index) in exerciseList"
          :key="index"
          :data="item"
          :index="index"
          practiceType="wrong"
          v-model="item.userKey"
          @on-check="changeProgress"
          @on-delete="deleteWrong"
        ></practice-item>
      </div>
      <div class="fr practice-bar">
        <Affix :offset-top="160">
          <div class="practice-sheet">
            <h3 class="practice-sheet-header">答题卡</h3>
            <p class="practice-sheet-note">点击图标跳转到对应的题目</p>
            <div class="practice-sheet-score" v-show="doResultVisible">
              <p>
                正确率
                <span class="right-rate">{{ rightPercent }}%</span>
              </p>
              <!-- <p>
                <span class="wrong-num">{{ rightExerciseNum }}</span>
                道题已从错题本删除
              </p> -->
            </div>
            <div class="practice-sheet-list">
              <happy-scroll
                color="rgba(12, 154, 213 , 1)"
                size="5"
                resize
                hide-horizontal
                v-if="exerciseList.length > 0"
              >
                <ul class="practice-sheet-serial clearfix">
				 <div v-if="singleFlag == true">单选题</div>
                  <li v-for="(item, index) in exerciseList"
                    :key="index"
                    :class="{
                      right: item.doResult == 1,
                      wrong: item.doResult == -1,
                    }"
					v-if="singleFlag == true && item.type_id == 1"
                  >
                    <a v-text="index + 1" @click="scrollPosition(index)"></a>
                  </li>

				  <div v-if="multipleFlag == true">多选题</div>
				   <li
				     v-for="(item, index) in exerciseList"
				     :key="index"
				     :class="{
				       right: item.doResult == 1,
				       wrong: item.doResult == -1,
				     }"
				  					v-if="multipleFlag == true && item.type_id == 2"
				   >
				     <a v-text="index + 1" @click="scrollPosition(index)"></a>
				   </li>

				   <div v-if="subjectiveFlag == true">主观题</div>
				    <li
				      v-for="(item, index) in exerciseList"
				      :key="index"
				      :class="{
				        right: item.doResult == 1,
				        wrong: item.doResult == -1,
				      }"
				   					v-if="subjectiveFlag == true && item.type_id == 3"
				    >
				      <a v-text="index + 1" @click="scrollPosition(index)"></a>
				    </li>
                </ul>
              </happy-scroll>
            </div>

            <div class="practice-sheet-button">
              <Button
                v-if="!doResultVisible"
                type="warning"
                long
                @click="submitExercise"
                >提交练习</Button
              >
              <Button v-else type="warning" long @click="reloadPage"
                >重做一遍</Button
              >
            </div>
            <div class="practice-sheet-footer">
              <span>
                <i class="ivu-icon ivu-icon-md-square right"></i> 正确
              </span>
              <span>
                <i class="ivu-icon ivu-icon-md-square wrong"></i> 错误
              </span>
              <span>
                <i class="ivu-icon ivu-icon-md-square empty"></i> 未做
              </span>
            </div>
          </div>
        </Affix>
      </div>
    </div>
  </div>
</div>
  </div>
</template>

<script>
// import { siteMixin } from "../../utils/mixin";
// import { mall, study } from "../../api/api";

import PracticeItem from "../../components/exercise/PracticeItem";
import {
  getCategoryInfo ,
  GetQuestionErrorList,
  QuestionDeleteError
} from "../../api/api";
import Header from '../../components/header.vue'
import { HappyScroll } from "vue-happy-scroll";
import "vue-happy-scroll/docs/happy-scroll.css";
export default {
  data() {
    return {
      cId: 0,
      categoryInfo: {}, // 课程详情
      exerciseList: [],
      finishExerciseNum: 0,
      courseName: "",
      catalogInfo: {},
      rightExerciseNum: 0,
      doResultVisible: false,
      exerSortType: 1, //答题排序
      singleFlag: false, //答题卡单选
      multipleFlag: false, //答题卡多选
      subjectiveFlag: false, //答题卡主观
    };
  },
  computed: {
    progressPercent() {
      const totalNum = this.exerciseList.length;
      if (totalNum <= 0) return 0;
      let percent = (this.finishExerciseNum / totalNum) * 100;
      return Number(percent.toFixed(0));
    },
    rightPercent() {
      const totalNum = this.exerciseList.length;
      if (totalNum <= 0) return 0;
      let rightNum = this.rightExerciseNum;
      let percent = (rightNum / totalNum) * 100;
      return Number(percent.toFixed(0));
    },
  },
  mounted() {
    //获取参数
    if (!this.initParams()) return;
    this.getExerciseList();
  },
  methods: {
    initParams() {
      let cId = this.$route.params.cid;
      this.cId = cId;
      if (cId) {
        return true;
      } else {
        this.$Message.error("参数错误");
        return false;
      }
    },
    getExerciseList() {
      GetQuestionErrorList({
        bankId: this.cId
      }).then((res) => {
          if (res.code === 1) {
            this.categoryInfo = res.data.bank;
            this.exerciseList = res.data.list;
            this.exerciseList.forEach((item) => {
              if (item.type_id == 1) {
                this.$set(item, "keyType", "单选");
                if(!this.singleFlag){
                  this.singleFlag = true;
                }
              }
              if (item.type_id == 2) {
                this.$set(item, "keyType", "多选");
                if(!this.multipleFlag){
                  this.multipleFlag = true;
                }
              }
              if (item.type_id == 3) {
                this.$set(item, "keyType", "材料");
                if(!this.subjectiveFlag){
                  this.subjectiveFlag = true;
                }
              }
              this.$set(item, "userKey", "");
              this.$set(item, "doResult", 0);
            });
          }
        });
    },
    deleteWrong(data) {
      //console.log("delete", data);
      if (data.doResult != 0) {
        this.finishExerciseNum--;
      }
      QuestionDeleteError({
          questionId: data.id
        }).then((res) => {
          if (res.code === 1) {
            const index = this.exerciseList.indexOf(data);
            this.exerciseList.splice(index, 1);
            this.$Message.info('删除成功');
          }
        });
    },
    submitExercise() {
      this.doResultVisible = true;
      //检查答案
      this.$refs.practiceItem.forEach((item) => {
        item.checkAnswer();
      });
      let exerIdSet = "";
      this.exerciseList.forEach((item) => {
        if (item.doResult == 1) {
          this.rightExerciseNum++;
          if (exerIdSet != "") exerIdSet += "|";
          exerIdSet += item.exerId;
        }
      });
      if (!exerIdSet) return;
      study
        .deleteWrongExercise({
          umcId: this.umcId,
          exerIds: exerIdSet,
        })
        .then((res) => {
          //console.log(res);
          if (res.status === 1) {
          }
        });
    },
    changeProgress(item) {
      this.finishExerciseNum++;
    },
    scrollPosition: function (i) {
      var top = document.querySelectorAll(".practice-item")[i].offsetTop - 162;
      window.scroll({ top: top, left: 0, behavior: "smooth" });
    },
    reloadPage() {
      window.location.reload();
    },
  },
  components: {
    Header,
    PracticeItem,
    HappyScroll,
  },
};
</script>

<style lang="less" scoped>
// @import "../../assets/css/var";
// @import "../../assets/css/exercise.css";
.breadcrumb {
  padding: 1rem 0;
  .home {
    vertical-align: -0.05em;
    margin-right: 0.2rem;
  }
}
.practice-nodata {
  text-align: center;
  padding: 35px;
  img {
    margin: 0 auto;
  }
  p {
    margin-top: 16px;
    text-align: center;
    font-size: 1.8rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/exercise/WrongBook.vue